import { DELETE_SPONSORS_LOADING, DELETE_SPONSORS_SUCCESS, DELETE_SPONSORS_ERROR } from "../../../constant/actionTypes";

const deleteSponsorReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_SPONSORS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case DELETE_SPONSORS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case DELETE_SPONSORS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default deleteSponsorReducer;